export function unreachable(
  x: never,
  msg = `unreachable code reached: ${x}`,
) {
  throw new Error(msg)
}
